<template>
  <v-app>
    <div id="app">
      <div v-if="this.$route.name == 'Top' && !basicAuth" class="basic-auth">
        <div style="margin-top: 10px;">
          <label>ID </label>
          <input v-model="id" placeholder="IDを入力してください" />
        </div>
        <div style="margin-top: 10px;">
          <label>パスワード </label>
          <input type="password" v-model="password" placeholder="パスワードを入力してください" />
        </div>
        <button @click="auth()" style="margin-top: 10px;">ログイン</button>
        <div v-if="message.length > 0" class="alert" style="color: red;">{{ message }}</div>
      </div>
      <div v-else>
        <header-top-app v-if="this.$route.name == 'Top'"></header-top-app>
        <header-app v-else></header-app>

        <router-view />
        <footer-app></footer-app>
      </div>
    </div>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";

export default {
  components: {
    "header-app": Header,
    "header-top-app": HeaderTop,
    "footer-app": Footer
  },
  data() {
    return {
      basicAuth: false,
      id: "",
      password: "",
      message: "",
    };
  },
  mounted() {
    if (process.env["NODE_ENV"] == "PROD") {
      this.basicAuth = true;
    } else {
      this.basicAuth = localStorage.auth == "true";
    }
  },
  methods: {
    auth() {
      if (
        this.id == process.env["VUE_APP_HTTP_BASIC_AUTH_ID"] &&
        this.password == process.env["VUE_APP_HTTP_BASIC_AUTH_PASSWORD"]
      ) {
        localStorage.auth = "true";
        this.basicAuth = true;
        this.$router.push({ path: '/' });
      } else {
        this.message = "IDもしくはパスワードが異なります。";
      }
    },
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "Great Vibes";
  src: url(./assets/fonts/GreatVibes-Regular.ttf);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#app{
  .v-application--wrap {
    @media screen and (max-width: 768px) {
      max-width: unset
    }
    @media screen and (max-width: 480px) {
      max-width: 100%;
    }
  }
}
#nav {
  padding: 30px;
}

#nav {
  a{
    font-weight: bold;
    color: #2c3e50;
  }
  a.router-link-exact-active {
    color: #42b983;
  }
}
.basic-auth {
  width: 400px;
  margin: auto;
  display: flex;
  flex-direction: column;
}

.basic-auth label {
  width: 80px;
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  text-align: left;
  font-weight: bold;
}

.basic-auth input {
  width: 300px;
  padding: 5px;
}

.basic-auth button {
  width: 30%;
  align-self: center;
  height: 35px;
  padding: 1px 6px;
  border: solid 1px;
  border-radius: 5px;
}

.basic-auth .alert {
  padding-left: 0px;
  text-align: center;
}

</style>
